import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'react-emotion';

const Button = styled('span')`
  cursor: pointer;
  color: ${props =>
    props.reversed ?
      props.active ? 'orange' : '#888' :
      props.active ? 'orange' : '#888'};
  &:hover{
    color: orange;
  }

  i{
    font-size: 18px;
    line-height: 22px;
    &.fa-xs{
      font-size: 13px;
      line-height: 16px;
    }
  }
`;

export default Button;
